import { formatarData, formatarValor } from '@/libs/utils'
import * as XLSX from 'xlsx'

const createSheet = (tableData: any[]) => {
  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.aoa_to_sheet([[]])
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório Geral')

  XLSX.utils.sheet_add_json(worksheet, tableData, { origin: -1 })

  XLSX.writeFile(workbook, 'Relatório de Parcelas - AGENDABANK.xlsx')
}

export const asDefault = () => {
  return {
    convertToExcelFormat: (item) => {
      return {
        'Nº Contrato': item.contract_number,
        'Nome Tomador': item.name,
        Parcela: item.installment_number,
        'Data de Criação': formatarData(item.contract_create_date),
        'Valor do Contrato': formatarValor(item.contract_value),
        'Valor da Parcela': formatarValor(item.installment_value),
        'Vencimento da Parcela': formatarData(item.installment_maturity_date),
        'Status do Contrato': item.contract_status,
        'Unidade Gestora': item.contract_institute,
      }
    },

    export: (items) => {
      const items_excel = items.map((item) => asDefault().convertToExcelFormat(item))

      const total_installment = items.reduce((acc, curr) => acc + Number(curr.installment_value || 0), 0)

      const total = {
        'Nº Contrato': 'Total: ',
        'Nome Tomador': '',
        Parcela: '',
        'Data de Criação': '',
        'Valor do Contrato': '',
        'Valor da Parcela': formatarValor(total_installment),
        'Vencimento da Parcela': '',
        'Status do Contrato': '',
        'Unidade Gestora': '',
      }

      items_excel.push(total)

      createSheet(items_excel)
    },
  }
}
